module.exports = __webpack_public_path__ + "img/arrow-bottom-white.e5b948d.svg";